import styled, { css } from "styled-components";

const DefaultTable = styled.table<{ isStick?: boolean }>`
    border-collapse: collapse;
    background: white;
    border-radius: 10px;
    width: 100%;
    margin: 0 auto;
    border-collapse: collapse;

    overflow: ${({ isStick }) => (isStick ? "auto" : "none")};

    ${({ isStick }) =>
        isStick &&
        css`
            thead {
                position: sticky;
                top: 0;
                z-index: 2;
                background-color: #fff;
                height: 5rem;
                margin-top: -2rem;
                border-bottom: 2px solid #e3e6f0;
            }
        `}

    thead th {
        color: #858796;
        font-weight: bold;
        text-align: left;
        vertical-align: bottom;
        border-bottom: 2px solid #e3e6f0;
    }

    tbody tr {
        height: 50px;
        font-family: Roboto, sans-serif;
        font-size: 15px;
        color: #808080;
        line-height: 1.2;
        font-weight: unset;
    }

    th,
    td {
        padding: 0.75rem;
        border: 1px solid #e3e6f0;
    }

    tbody tr:hover {
        color: #555555;
        background-color: #f5f5f5;
    }
    a {
        color: inherit;
    }
`;

export { DefaultTable };
